import { DateTime } from "luxon"

import { authFetch } from "@/api/authFetch"
import { API_BASE } from "@/config"

import type { Farm } from "../types/logisticsTypes"

export const getFarmDriverTrips = async (driverId: number, asOf: Date): Promise<Farm[]> => {
  const start = DateTime.fromJSDate(asOf).setZone("America/Chicago").startOf("month")

  const res = await authFetch(
    `${API_BASE}/logistics/farms?includeTrips=true&start=${start.toISO()}&end=${asOf.toISOString()}&driverId=${driverId}`,
  )
  const data: Farm[] = await res.json()

  return data
}
